import { render, staticRenderFns } from "./attachmentSvg.vue?vue&type=template&id=ef249ff6"
import script from "./attachmentSvg.vue?vue&type=script&lang=js"
export * from "./attachmentSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports